import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#customizable-close-button" }),
  /*#__PURE__*/_createTextVNode(" Customizable close button ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Customize the close button as texts or other symbols. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_alert, {
        class: "mb-5",
        title: "unclosable alert",
        type: "success",
        closable: false
      }),
      _createVNode(_component_el_alert, {
        class: "mb-5",
        title: "customized close-text",
        type: "info",
        "close-text": "Gotcha"
      }),
      _createVNode(_component_el_alert, {
        title: "alert with callback",
        type: "warning",
        onClose: _ctx.hello
      }, null, 8, ["onClose"]),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code3), 1)
        ]),
        _: 1
      })
    ])
  ]))
}